var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "noun_Draw_3406101",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20.961,
    viewBox: "0 0 21 20.961",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_437",
    "data-name": "Path 437",
    d: "M22.613,6.3,19.653,3.337a2.923,2.923,0,0,0-4.043,0L4.474,14.45a3.3,3.3,0,0,0-.884,1.635l-1.1,5.5a1.6,1.6,0,0,0,1.569,1.9,1.359,1.359,0,0,0,.309-.022l5.5-1.1a3.222,3.222,0,0,0,1.635-.884L22.613,10.363a2.875,2.875,0,0,0,.84-2.033A2.914,2.914,0,0,0,22.613,6.3ZM9.931,19.908a.876.876,0,0,1-.508.265l-4.6.928.928-4.6A1.127,1.127,0,0,1,6.02,16l7.954-7.954,3.889,3.889ZM21.045,8.794l-1.613,1.613L15.543,6.519l1.613-1.613a.641.641,0,0,1,.928,0l2.961,2.961A.641.641,0,0,1,21.045,8.794Z",
    transform: "translate(-2.453 -2.525)",
    fill: "#4795de"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditActiveIcon);
export default __webpack_public_path__ + "static/media/editActiveIcon.6e1cb24f10015da5cb300f7b4963e767.svg";
export { ForwardRef as ReactComponent };